import styled from "styled-components";

export const Lists = styled.div
`h3{
    color: #FFF;
    text-transform: capitalize;
    font-size: 18px;
    border-bottom: 1px solid #FFF;
    padding-bottom: 10px;
}
ul{
    border-radius: 0;
    li{
        background: #6c757d4d;
        color:#FFF;
        border: none ;
        border-bottom: 1px solid #8f8f8f;
        svg{
            color: #fff;
            margin-right: 5px;
        }
        span{
            font-size: 12px;
            color: #4d90fe;
        }
    }
}
`